(function () {
  'use strict';

  function loadScript(src, onload) {
    if (document.querySelector('script[src="' + src + '"]')) {
      if (onload) onload();
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    if (onload) script.onload = onload;
    document.body.appendChild(script);
  }

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function observeSection(root, boot) {
    if (!root || typeof boot !== 'function') return;

    if (!('IntersectionObserver' in window)) {
      boot();
      return;
    }

    var started = false;
    function run() {
      if (started) return;
      started = true;
      boot();
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          observer.disconnect();
          run();
        }
      },
      { rootMargin: '320px 0px' }
    );

    observer.observe(root);
    setTimeout(run, 6000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tm-lazy-section]').forEach(function (root) {
      var scriptSrc = root.getAttribute('data-tm-lazy-script');
      var styleHref = root.getAttribute('data-tm-lazy-style');

      observeSection(root, function () {
        if (styleHref) loadStylesheet(styleHref);
        if (scriptSrc) loadScript(scriptSrc);
      });
    });
  });
})();
